// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.property-item {
  height: 100%;
  overflow: hidden;
}
.property-item .thumbnail-section {
  position: relative;
}
.property-item .mat-card-image {
  position: relative;
  min-height: 207px;
}
.property-item .mat-card-image .swiper-container .swipe-arrow {
  color: #fff;
}
.property-item .mat-card-image .swiper-container .swipe-arrow.swiper-button-next {
  right: 4px;
}
.property-item .mat-card-image .swiper-container .swipe-arrow.swiper-button-prev {
  left: 4px;
}
.property-item .mat-card-image .swiper-slide {
  text-align: center;
  padding-bottom: 66.25%;
  position: relative;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.04);
}
.property-item .mat-card-image img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
}
.property-item .property-status {
  position: absolute;
  z-index: 2;
  right: 0px;
  opacity: 0.9;
}
.property-item .property-status span {
  padding: 3px 6px;
  margin: 4px;
  font-size: 15px;
  color: #fff;
  text-transform: uppercase;
  border-radius: 4px;
}
.property-item .title {
  font-size: 18px;
}
.property-item .title a {
  transition: 0.2s;
  text-decoration: none;
}
.property-item .address,
.property-item .date {
  font-style: italic;
  margin-top: 8px;
}
.property-item .address .mat-icon,
.property-item .date .mat-icon {
  margin-left: -4px;
}
.property-item .price span {
  display: block;
}
.property-item .features p span:first-child {
  float: left;
  padding: 0 0.4em 0 0;
}
.property-item .features p span + span {
  float: right;
  padding: 0 0 0 0.4em;
}
.property-item .features p:after {
  content: "";
  display: block;
  overflow: hidden;
  height: 1em;
}
.property-item .control-icons {
  position: absolute;
  z-index: 2;
  right: 2px;
  margin-top: -30px;
}
.property-item .control-icons button.mat-button {
  min-width: 26px;
  width: 26px;
  line-height: 26px;
  padding: 0;
  margin: 0 4px;
  background: rgba(255, 252, 252, 0.6);
  transition: 0.2s;
  color: rgba(0, 0, 0, 0.87);
}
.property-item .control-icons button.mat-button:disabled {
  color: rgba(0, 0, 0, 0.26);
}
.property-item .control-icons button.mat-button:hover:enabled {
  background: rgb(255, 252, 252);
}
.property-item.grid-item {
  flex-flow: column !important;
}
.property-item.grid-item.column-2 .title {
  font-size: 22px;
}
.property-item.grid-item.column-2 .price {
  font-size: 18px;
}
.property-item.grid-item.column-3 .title {
  font-size: 18px;
}
.property-item.grid-item.column-3 .address,
.property-item.grid-item.column-3 .date {
  font-size: 12px;
}
.property-item.grid-item.column-3 .address .mat-icon,
.property-item.grid-item.column-3 .date .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.property-item.grid-item.full-width-page.column-2 .title {
  font-size: 28px;
}
.property-item.grid-item.full-width-page.column-2 .price {
  font-size: 20px;
}
.property-item.grid-item.full-width-page.column-3 .title {
  font-size: 22px;
}
.property-item.grid-item.full-width-page.column-3 .address,
.property-item.grid-item.full-width-page.column-3 .date {
  font-size: 14px;
}
.property-item.grid-item.full-width-page.column-3 .address .mat-icon,
.property-item.grid-item.full-width-page.column-3 .date .mat-icon {
  font-size: 24px;
  width: 24px;
  height: 24px;
}
.property-item.grid-item.full-width-page.column-3 .price {
  font-size: 18px;
}
.property-item.grid-item.full-width-page.column-4 .title {
  font-size: 18px;
}
.property-item.grid-item.full-width-page.column-4 .address,
.property-item.grid-item.full-width-page.column-4 .date {
  font-size: 12px;
}
.property-item.grid-item.full-width-page.column-4 .address .mat-icon,
.property-item.grid-item.full-width-page.column-4 .date .mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.property-item.list-item .title {
  font-size: 28px;
  margin-top: -8px;
}
.property-item.list-item .price {
  font-size: 20px;
}
.property-item.list-item .features {
  display: flex;
  flex-flow: wrap;
}
.property-item.list-item .features p {
  margin-right: 24px;
  display: flex;
  white-space: nowrap;
}
.property-item.list-item .features p span:first-child:after {
  content: ":";
  margin: 0 1px;
}
.property-item.list-item .features p:after {
  content: none;
}

.c-button-fav {
  color: white !important;
  padding: 0px !important;
  float: right;
  position: absolute;
  right: -15px;
  top: -10px;
  --mdc-text-button-label-text-color: transparent !important;
  --mat-mdc-button-persistent-ripple-color: transparent !important;
}

button.mat-button {
  min-width: 26px;
  width: 26px;
  line-height: 26px;
  padding: 0;
  margin: 0 4px;
  background: rgba(255, 252, 252, 0.6) !important;
  transition: 0.2s;
  color: rgba(0, 0, 0, 0.87);
}
button.mat-button:disabled {
  color: rgba(0, 0, 0, 0.26);
}
button.mat-button:hover:enabled {
  background: rgb(255, 252, 252) !important;
}

@media screen and (max-width: 959px) {
  .property-item.grid-item .title {
    font-size: 22px;
  }
  .property-item.grid-item.column-2 .title {
    font-size: 22px;
  }
  .property-item.grid-item.full-width-page.column-2 .title {
    font-size: 22px;
  }
  .property-item.list-item .title {
    font-size: 22px;
  }
  .property-item.list-item .address,
  .property-item.list-item .date {
    font-size: 12px;
  }
  .property-item.list-item .address .mat-icon,
  .property-item.list-item .date .mat-icon {
    font-size: 18px;
    width: 18px;
    height: 18px;
  }
  .property-item.list-item .price {
    font-size: 18px;
  }
}
.c-byggingargerd {
  font-size: 14px;
}

.c-price {
  font-weight: bold;
  float: left;
  margin-top: 3px;
}

.c-banner-1 {
  background-color: #558b2f;
}

.c-banner-2 {
  background-color: #1e88e5;
}

.c-banner-3 {
  background-color: #009688;
}

.c-banner-4 {
  background-color: #01579b;
}

.c-banner-5 {
  background-color: #f44336;
}

.c-banner-6 {
  background-color: #000;
}

.c-banner-opid-hus {
  bottom: 10px;
  position: absolute;
  right: 5px;
}

.c-banner-opid-hus span {
  text-transform: none !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-weight: 600;
  background-color: rgba(255, 252, 252, 0.87) !important;
}

.mat-mdc-icon-button {
  --mat-mdc-button-persistent-ripple-color: transparent !important;
}

.c-location-icon {
  width: 34px !important;
  height: 40px !important;
  font-size: 30px !important;
  margin-left: 3px !important;
  margin-top: 3px !important;
}

.features p {
  line-height: 1.35;
}

.features span:first-child {
  color: var(--text-muted);
  display: inline-block;
}

.features .block {
  font-weight: 500;
}

.swiper-single-image {
  object-fit: contain;
  background-color: #f0f0f0;
  /* eða t.d. #e0e0e0 fyrir dekkra */
}`, "",{"version":3,"sources":["webpack://./src/app/shared/property-item-for-sale/property-item-for-sale.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,YAAA;EACA,gBAAA;AAEF;AAAE;EACE,kBAAA;AAEJ;AACE;EACE,kBAAA;EACA,iBAAA;AACJ;AAEM;EACE,WAAA;AAAR;AAEQ;EACE,UAAA;AAAV;AAGQ;EACE,SAAA;AADV;AAMI;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;AAJN;AAOI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;AALN;AASE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,YAAA;AAPJ;AASI;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;AAPN;AAWE;EACE,eAAA;AATJ;AAWI;EACE,gBAAA;EACA,qBAAA;AATN;AAaE;;EAEE,kBAAA;EACA,eAAA;AAXJ;AAaI;;EACE,iBAAA;AAVN;AAeI;EACE,cAAA;AAbN;AAmBM;EACE,WAAA;EACA,oBAAA;AAjBR;AAoBM;EACE,YAAA;EACA,oBAAA;AAlBR;AAsBI;EACE,WAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;AApBN;AAwBE;EACE,kBAAA;EACA,UAAA;EACA,UAAA;EACA,iBAAA;AAtBJ;AAwBI;EACE,eAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,oCAAA;EACA,gBAAA;EACA,0BAAA;AAtBN;AAwBM;EACE,0BAAA;AAtBR;AAyBM;EACE,8BAAA;AAvBR;AA4BE;EACE,4BAAA;AA1BJ;AA6BM;EACE,eAAA;AA3BR;AA8BM;EACE,eAAA;AA5BR;AAiCM;EACE,eAAA;AA/BR;AAkCM;;EAEE,eAAA;AAhCR;AAkCQ;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/BV;AAsCQ;EACE,eAAA;AApCV;AAuCQ;EACE,eAAA;AArCV;AA0CQ;EACE,eAAA;AAxCV;AA2CQ;;EAEE,eAAA;AAzCV;AA2CU;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxCZ;AA4CQ;EACE,eAAA;AA1CV;AA+CQ;EACE,eAAA;AA7CV;AAgDQ;;EAEE,eAAA;AA9CV;AAgDU;;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA7CZ;AAqDI;EACE,eAAA;EACA,gBAAA;AAnDN;AAsDI;EACE,eAAA;AApDN;AAuDI;EACE,aAAA;EACA,eAAA;AArDN;AAuDM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;AArDR;AAuDQ;EACE,YAAA;EACA,aAAA;AArDV;AAwDQ;EACE,aAAA;AAtDV;;AA6DA;EACE,uBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,0DAAA;EACA,gEAAA;AA1DF;;AA6DA;EACE,eAAA;EACA,WAAA;EACA,iBAAA;EACA,UAAA;EACA,aAAA;EACA,+CAAA;EACA,gBAAA;EACA,0BAAA;AA1DF;AA4DE;EACE,0BAAA;AA1DJ;AA6DE;EACE,yCAAA;AA3DJ;;AA+DA;EAGM;IACE,eAAA;EA9DN;EAkEM;IACE,eAAA;EAhER;EAsEQ;IACE,eAAA;EApEV;EA2EI;IACE,eAAA;EAzEN;EA4EI;;IAEE,eAAA;EA1EN;EA4EM;;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAzER;EA6EI;IACE,eAAA;EA3EN;AACF;AAgFA;EACE,eAAA;AA9EF;;AAiFA;EACE,iBAAA;EACA,WAAA;EACA,eAAA;AA9EF;;AAiFA;EACE,yBAAA;AA9EF;;AAiFA;EACE,yBAAA;AA9EF;;AAiFA;EACE,yBAAA;AA9EF;;AAiFA;EACE,yBAAA;AA9EF;;AAiFA;EACE,yBAAA;AA9EF;;AAiFA;EACE,sBAAA;AA9EF;;AAiFA;EACE,YAAA;EACA,kBAAA;EACA,UAAA;AA9EF;;AAiFA;EACE,+BAAA;EACA,qCAAA;EACA,gBAAA;EACA,sDAAA;AA9EF;;AAiFA;EACE,gEAAA;AA9EF;;AAiFA;EACE,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,2BAAA;EACA,0BAAA;AA9EF;;AAiFA;EACE,iBAAA;AA9EF;;AAiFA;EACE,wBAAA;EACA,qBAAA;AA9EF;;AAiFA;EACE,gBAAA;AA9EF;;AAiFA;EACE,mBAAA;EACA,yBAAA;EACA,kCAAA;AA9EF","sourcesContent":[".property-item {\r\n  height: 100%;\r\n  overflow: hidden;\r\n\r\n  .thumbnail-section {\r\n    position: relative;\r\n  }\r\n\r\n  .mat-card-image {\r\n    position: relative;\r\n    min-height: 207px;\r\n\r\n    .swiper-container {\r\n      .swipe-arrow {\r\n        color: #fff;\r\n\r\n        &.swiper-button-next {\r\n          right: 4px;\r\n        }\r\n\r\n        &.swiper-button-prev {\r\n          left: 4px;\r\n        }\r\n      }\r\n    }\r\n\r\n    .swiper-slide {\r\n      text-align: center;\r\n      padding-bottom: 66.25%;\r\n      position: relative;\r\n      overflow: hidden;\r\n      background: rgba(0, 0, 0, 0.04);\r\n    }\r\n\r\n    img {\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      width: 100%;\r\n      height: auto;\r\n    }\r\n  }\r\n\r\n  .property-status {\r\n    position: absolute;\r\n    z-index: 2;\r\n    right: 0px;\r\n    opacity: 0.9;\r\n\r\n    span {\r\n      padding: 3px 6px;\r\n      margin: 4px;\r\n      font-size: 15px;\r\n      color: #fff;\r\n      text-transform: uppercase;\r\n      border-radius: 4px;\r\n    }\r\n  }\r\n\r\n  .title {\r\n    font-size: 18px;\r\n\r\n    a {\r\n      transition: 0.2s;\r\n      text-decoration: none;\r\n    }\r\n  }\r\n\r\n  .address,\r\n  .date {\r\n    font-style: italic;\r\n    margin-top: 8px;\r\n\r\n    .mat-icon {\r\n      margin-left: -4px;\r\n    }\r\n  }\r\n\r\n  .price {\r\n    span {\r\n      display: block;\r\n    }\r\n  }\r\n\r\n  .features p {\r\n    span {\r\n      &:first-child {\r\n        float: left;\r\n        padding: 0 0.4em 0 0;\r\n      }\r\n\r\n      +span {\r\n        float: right;\r\n        padding: 0 0 0 0.4em;\r\n      }\r\n    }\r\n\r\n    &:after {\r\n      content: \"\";\r\n      display: block;\r\n      overflow: hidden;\r\n      height: 1em;\r\n    }\r\n  }\r\n\r\n  .control-icons {\r\n    position: absolute;\r\n    z-index: 2;\r\n    right: 2px;\r\n    margin-top: -30px;\r\n\r\n    button.mat-button {\r\n      min-width: 26px;\r\n      width: 26px;\r\n      line-height: 26px;\r\n      padding: 0;\r\n      margin: 0 4px;\r\n      background: rgba(255, 252, 252, 0.6);\r\n      transition: 0.2s;\r\n      color: rgba(0, 0, 0, 0.87);\r\n\r\n      &:disabled {\r\n        color: rgba(0, 0, 0, 0.26);\r\n      }\r\n\r\n      &:hover:enabled {\r\n        background: rgba(255, 252, 252, 1);\r\n      }\r\n    }\r\n  }\r\n\r\n  &.grid-item {\r\n    flex-flow: column !important;\r\n\r\n    &.column-2 {\r\n      .title {\r\n        font-size: 22px;\r\n      }\r\n\r\n      .price {\r\n        font-size: 18px;\r\n      }\r\n    }\r\n\r\n    &.column-3 {\r\n      .title {\r\n        font-size: 18px;\r\n      }\r\n\r\n      .address,\r\n      .date {\r\n        font-size: 12px;\r\n\r\n        .mat-icon {\r\n          font-size: 18px;\r\n          width: 18px;\r\n          height: 18px;\r\n        }\r\n      }\r\n    }\r\n\r\n    &.full-width-page {\r\n      &.column-2 {\r\n        .title {\r\n          font-size: 28px;\r\n        }\r\n\r\n        .price {\r\n          font-size: 20px;\r\n        }\r\n      }\r\n\r\n      &.column-3 {\r\n        .title {\r\n          font-size: 22px;\r\n        }\r\n\r\n        .address,\r\n        .date {\r\n          font-size: 14px;\r\n\r\n          .mat-icon {\r\n            font-size: 24px;\r\n            width: 24px;\r\n            height: 24px;\r\n          }\r\n        }\r\n\r\n        .price {\r\n          font-size: 18px;\r\n        }\r\n      }\r\n\r\n      &.column-4 {\r\n        .title {\r\n          font-size: 18px;\r\n        }\r\n\r\n        .address,\r\n        .date {\r\n          font-size: 12px;\r\n\r\n          .mat-icon {\r\n            font-size: 18px;\r\n            width: 18px;\r\n            height: 18px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  &.list-item {\r\n    .title {\r\n      font-size: 28px;\r\n      margin-top: -8px;\r\n    }\r\n\r\n    .price {\r\n      font-size: 20px;\r\n    }\r\n\r\n    .features {\r\n      display: flex;\r\n      flex-flow: wrap;\r\n\r\n      p {\r\n        margin-right: 24px;\r\n        display: flex;\r\n        white-space: nowrap;\r\n\r\n        span:first-child:after {\r\n          content: \":\";\r\n          margin: 0 1px;\r\n        }\r\n\r\n        &:after {\r\n          content: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.c-button-fav {\r\n  color: white !important;\r\n  padding: 0px !important;\r\n  float: right;\r\n  position: absolute;\r\n  right: -15px;\r\n  top: -10px;\r\n  --mdc-text-button-label-text-color: transparent !important;\r\n  --mat-mdc-button-persistent-ripple-color: transparent !important;\r\n}\r\n\r\nbutton.mat-button {\r\n  min-width: 26px;\r\n  width: 26px;\r\n  line-height: 26px;\r\n  padding: 0;\r\n  margin: 0 4px;\r\n  background: rgba(255, 252, 252, 0.6) !important;\r\n  transition: 0.2s;\r\n  color: rgba(0, 0, 0, 0.87);\r\n\r\n  &:disabled {\r\n    color: rgba(0, 0, 0, 0.26);\r\n  }\r\n\r\n  &:hover:enabled {\r\n    background: rgba(255, 252, 252, 1) !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 959px) {\r\n  .property-item {\r\n    &.grid-item {\r\n      .title {\r\n        font-size: 22px;\r\n      }\r\n\r\n      &.column-2 {\r\n        .title {\r\n          font-size: 22px;\r\n        }\r\n      }\r\n\r\n      &.full-width-page {\r\n        &.column-2 {\r\n          .title {\r\n            font-size: 22px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n\r\n    &.list-item {\r\n      .title {\r\n        font-size: 22px;\r\n      }\r\n\r\n      .address,\r\n      .date {\r\n        font-size: 12px;\r\n\r\n        .mat-icon {\r\n          font-size: 18px;\r\n          width: 18px;\r\n          height: 18px;\r\n        }\r\n      }\r\n\r\n      .price {\r\n        font-size: 18px;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.c-byggingargerd {\r\n  font-size: 14px;\r\n}\r\n\r\n.c-price {\r\n  font-weight: bold;\r\n  float: left;\r\n  margin-top: 3px;\r\n}\r\n\r\n.c-banner-1 {\r\n  background-color: #558b2f;\r\n}\r\n\r\n.c-banner-2 {\r\n  background-color: #1e88e5;\r\n}\r\n\r\n.c-banner-3 {\r\n  background-color: #009688;\r\n}\r\n\r\n.c-banner-4 {\r\n  background-color: #01579b;\r\n}\r\n\r\n.c-banner-5 {\r\n  background-color: #f44336;\r\n}\r\n\r\n.c-banner-6 {\r\n  background-color: #000;\r\n}\r\n\r\n.c-banner-opid-hus {\r\n  bottom: 10px;\r\n  position: absolute;\r\n  right: 5px;\r\n}\r\n\r\n.c-banner-opid-hus span {\r\n  text-transform: none !important;\r\n  color: rgba(0, 0, 0, 0.87) !important;\r\n  font-weight: 600;\r\n  background-color: rgba(255, 252, 252, 0.87) !important;\r\n}\r\n\r\n.mat-mdc-icon-button {\r\n  --mat-mdc-button-persistent-ripple-color: transparent !important;\r\n}\r\n\r\n.c-location-icon {\r\n  width: 34px !important;\r\n  height: 40px !important;\r\n  font-size: 30px !important;\r\n  margin-left: 3px !important;\r\n  margin-top: 3px !important;\r\n}\r\n\r\n.features p {\r\n  line-height: 1.35;\r\n}\r\n\r\n.features span:first-child {\r\n  color: var(--text-muted);\r\n  display: inline-block;\r\n}\r\n\r\n.features .block {\r\n  font-weight: 500;\r\n}\r\n\r\n.swiper-single-image {\r\n  object-fit: contain;\r\n  background-color: #f0f0f0;\r\n  /* eða t.d. #e0e0e0 fyrir dekkra */\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
